import { Record } from 'immutable';
import castArray from 'lodash-es/castArray';
import find from 'lodash-es/find';

import { 
    TOGGLE_SIDEBAR,
    SET_SIDEBAR_ITEMS,
    SET_SELECTED_SIDEBAR_ITEM,
} from 'store/actions/sidebarActions';
import { REFRESH_VIEW } from 'store/actions/listActions';
import { 
    TOP_MENU_DOCUMENT,
    SIDEBAR_TYPE_DIVIDER,
    SIDEBAR_TYPE_ETC,
    LIST_INFO,
    DOCUMENT_REGISTRATION_ROUTES,
    DOCUMENT_DEIDENTIFICATION_ROUTES,
    DOCUMENT_GRAPH_VISUALIZATION_ROUTES
} from 'util/constants';
// import { 
//     isApplicationAdmin, 
//     isCompanyAdmin
// } from 'util/common';

// 초기상태 정의 
const initialState = Record({
        loadingVersion: 0,
        sidebarOpen: true,
        sidebarItems: [],//List(),
        selectedSidebarItem: {},
        refreshVersion: 0
})();

const dividerSidebarItem = { type: SIDEBAR_TYPE_DIVIDER };

const sidebarReducer = ( state = initialState, { type, payload, meta} ) => {
    //console.log("sidebarReducer type:",type,"/state:", state)
    switch (type) {
        case SET_SIDEBAR_ITEMS:
            const sidebarItems = makeSidebarItems(payload.topMenu, payload.isApplicationAdmin, payload.isCompanyAdmin);
            if( sidebarItems ) {
                const sidebarItem = find( sidebarItems, ["id", payload.subMenu] );
                return state.set('sidebarItems', sidebarItems)
                            .set('selectedSidebarItem', sidebarItem);
            }
            return state;

        case SET_SELECTED_SIDEBAR_ITEM:
            const sidebarItem = find( state.sidebarItems, ["id", payload] );
            if( sidebarItem ) {
                return state.set('selectedSidebarItem', sidebarItem);
            }
            return state;

        // header에서 sidebar메뉴 toggle
        case TOGGLE_SIDEBAR:
            return state.update('sidebarOpen', sidebarOpen => !sidebarOpen);

        case REFRESH_VIEW:
        return state.update('refreshVersion', refreshVersion => refreshVersion + 1);

        default:
            return state;
    }
}


// 사이드바 메뉴 
function makeSidebarItems( topMenu, isApplicationAdmin, isCompanyAdmin ) {
    if( TOP_MENU_DOCUMENT === topMenu ) {

        const sidebarItems =  castArray({
                type: SIDEBAR_TYPE_ETC,
                id: "file",
                sidebarName: `sidebar.${topMenu}.file`,
                path: LIST_INFO["document.file"].PATH,
                iconType: 'EventNote'
            });

        // 문서 등록 메뉴 
        const registrationMenus = DOCUMENT_REGISTRATION_ROUTES.map( route => ({
            ...route,
            type: SIDEBAR_TYPE_ETC,
            sidebarName: `sidebar.${topMenu}.${route.id}`
        }));

        // 비식별화 메뉴 
        const deIdentificationMenus = DOCUMENT_DEIDENTIFICATION_ROUTES.map( route => ({
            ...route,
            type: SIDEBAR_TYPE_ETC,
            sidebarName: `sidebar.${topMenu}.${route.id}`
        }));

        const graphVisualizationMenus = DOCUMENT_GRAPH_VISUALIZATION_ROUTES.map( route => ({
            ...route,
            type: SIDEBAR_TYPE_ETC,
            sidebarName: `sidebar.${topMenu}.${route.id}`
        }));

        return sidebarItems
            .concat(registrationMenus)
            .concat(dividerSidebarItem)
            .concat(deIdentificationMenus)
            .concat(graphVisualizationMenus);
    } 

}

export default sidebarReducer;